import KeyboardArrowDownRoundedIcon from '@mui/icons-material/KeyboardArrowDownRounded';
import { Box, Switch } from '@mui/material';
import React, { useState } from 'react';

interface AccordionProps {
  containerClassname?: string;
  index: number;
  title: string;
  open?: boolean;
  children: React.ReactNode;
  isActive?: boolean;
  onChangeActive?: (value: boolean) => void;
  isError?: boolean;
  isHideContent?: boolean;
}

export const StepAccordion: React.FC<AccordionProps> = ({
  containerClassname,
  title,
  open = false,
  children,
  index,
  isActive,
  onChangeActive,
  isError = false,
  isHideContent = false,
}) => {
  const [isOpen, setIsOpen] = useState(open);

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  return (
    <Box
      border={isError ? '1px solid #D32F2F' : 'none'}
      className={`rounded-[16px] bg-[#ffffff07] p-8 ${containerClassname || ''}`}>
      <div className='flex items-center justify-between cursor-pointer' onClick={toggleAccordion}>
        <div className='flex gap-x-4'>
          <div className='flex h-8 w-8 items-center justify-center rounded-[100px] bg-[#ffffff26] px-2 py-1'>
            <span className='text-[20px] font-bold text-white'>{index}</span>
          </div>
          <h3 className='text-[24px] font-bold leading-7 text-[white]'>{title}</h3>
        </div>
        <div className='flex gap-4'>
          {isActive !== undefined && onChangeActive && (
            <Switch
              onClick={e => {
                e.stopPropagation();
                e.preventDefault();
                onChangeActive(!isActive);
              }}
              sx={{
                width: '58px',
              }}
              checked={isActive}
            />
          )}
          <KeyboardArrowDownRoundedIcon
            sx={{
              color: 'white',
              width: '32px',
              height: '32px',
              transform: `rotate(${isOpen ? '180deg' : '0'})`,
              transition: 'all 0.25s ease',
            }}
          />
        </div>
      </div>
      {!isHideContent && (
        <div
          style={{
            maxHeight: isOpen ? '10000px' : '0px',
            overflow: 'hidden',
            transition: 'all 0.25s ease',
          }}
          className='accordion-content'>
          <div className='mt-6'>{children}</div>
        </div>
      )}
    </Box>
  );
};
